import { useCallback } from 'react'

const parseSessionValue = (value) => {
  if (value === null || value === undefined) {
    return null
  }

  try {
    return JSON.parse(value)
  } catch (_error) {
    return value
  }
}

const stringifySessionValue = (value) => {
  if (typeof value === 'string') {
    return value
  }

  return JSON.stringify(value)
}

export const useSessionStorage = () => {
  const readSession = useCallback((key, fallbackValue = null) => {
    if (typeof window === 'undefined') {
      return fallbackValue
    }

    const storedValue = window.sessionStorage.getItem(key)

    if (storedValue === null || storedValue === undefined) {
      return fallbackValue
    }

    return parseSessionValue(storedValue)
  }, [])

  const writeSession = useCallback((key, value) => {
    if (typeof window === 'undefined') {
      return value
    }

    window.sessionStorage.setItem(key, stringifySessionValue(value))
    return value
  }, [])

  const removeSession = useCallback((key) => {
    if (typeof window === 'undefined') {
      return
    }

    window.sessionStorage.removeItem(key)
  }, [])

  const updateSession = useCallback((key, updater, fallbackValue = null) => {
    const currentValue = readSession(key, fallbackValue)
    const nextValue = typeof updater === 'function' ? updater(currentValue) : updater

    writeSession(key, nextValue)
    return nextValue
  }, [readSession, writeSession])

  return {
    readSession,
    writeSession,
    removeSession,
    updateSession,
  }
}

export default useSessionStorage
